<script lang="ts" setup>
const props=defineProps({
    title: {
        type: String,
        required : true
    }, 
    image: {
        type: String,
        required : false
    },  
    excerpt: {
        type: String,
        required : true
    }, 
    slug: {
        type: String,
        required : true
    },
})
</script>


<template>
      <div class="max-w-sm bg-cyan-800 p-3 rounded border-slate-950 
      overflow-hidden shadow-lg mb-4 hover:shadow-2xl" >
        <!-- <img v-if="image"
          class="w-full"
          src={{ image }}
          alt="post image"
        /> -->
        <NuxtLink :to="`/post/${slug}`">
        <div class="px-6 py-4 pb-2">
          <div class="font-bold text-xl text-sky-50 mb-2">{{ title }}</div>
          <!-- <p class="text-gray-700 text-base"> -->
            <client-only>
          <p class="text-sky-200 text-base" v-html="excerpt"></p>
        </client-only>
          <!-- </p> -->
        
        </div>
      </NuxtLink> 
    </div>
  </template>
  
  <style lang="postcss" scoped>
  .badge {
    @apply inline-block bg-cyan-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700;
    &:hover {
      @apply bg-gray-100;
    }
  }
  </style>